import { IntlFormatters } from 'react-intl';

const getPointsLabel = (points: number, formatMessage: IntlFormatters['formatMessage']) =>
  formatMessage({ id: 'crownsEarned' }, { points });

export default getPointsLabel;
